
class EnvHelper {
    public static isDevelopmentQa = () => {
        return ENV_NAME === 'qa';
    }

    public static getEnvName = () : string => {
        if (ENV_NAME === 'production') {
            return 'PACKMAN';
        } else if (ENV_NAME === 'qa') {
            return 'PACKMAN QA';
        } else if (ENV_NAME === 'dev') {
            return 'PACKMAN DEV';
        } else {
            return 'PACKMAN ENV NOT FOUND';
        }
    };
}

export default EnvHelper;